<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { primary200, primary600 } = $AppState.theme.colors;
</script>

<svg
  width="32"
  height="32"
  viewBox="0 0 32 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width="32" height="32" rx="8" fill={primary600} />
  <path
    d="M21 12.6666C22.3807 12.6666 23.5 11.5473 23.5 10.1666C23.5 8.78591 22.3807 7.66663 21 7.66663C19.6193 7.66663 18.5 8.78591 18.5 10.1666C18.5 11.5473 19.6193 12.6666 21 12.6666Z"
    stroke={primary200}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M11 18.5C12.3807 18.5 13.5 17.3807 13.5 16C13.5 14.6193 12.3807 13.5 11 13.5C9.61929 13.5 8.5 14.6193 8.5 16C8.5 17.3807 9.61929 18.5 11 18.5Z"
    stroke={primary200}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M21 24.3334C22.3807 24.3334 23.5 23.2141 23.5 21.8334C23.5 20.4527 22.3807 19.3334 21 19.3334C19.6193 19.3334 18.5 20.4527 18.5 21.8334C18.5 23.2141 19.6193 24.3334 21 24.3334Z"
    stroke={primary200}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M13.5 17.25L18.5 20.1667"
    stroke={primary200}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M18.5 11.4166L13.5 14.3333"
    stroke={primary200}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
